import { render, staticRenderFns } from "./ActionComponent.vue?vue&type=template&id=56f15ca5&scoped=true"
import script from "./ActionComponent.vue?vue&type=script&lang=js"
export * from "./ActionComponent.vue?vue&type=script&lang=js"
import style0 from "./ActionComponent.vue?vue&type=style&index=0&id=56f15ca5&prod&scoped=true&lang=css"
import style1 from "./ActionComponent.vue?vue&type=style&index=1&id=56f15ca5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f15ca5",
  null
  
)

export default component.exports